import i18next from "i18next";
import { Link } from "react-router-dom";
import { LogoLink, LogoSubtitle, LogoText, LogoWrapper, Wrapper } from "./style";

const HeaderLogoComponent = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <LogoWrapper>
        <LogoLink to="/">
          <img src="/images/logo/as.dushanbe24-logo.png" alt="Dushanbe24-logo" />
        </LogoLink>
        <Link to="/scoreboard">
          <LogoSubtitle>{t("online_airport_board") || "Online airport board"}</LogoSubtitle>
        </Link>
      </LogoWrapper>
    </Wrapper>
  );
};

export default HeaderLogoComponent;
